(() => {
  const PICKER_SELECTOR = 'variant-radios, variant-selects';
  const GROUP_SELECTOR = 'fieldset.product-form__input';
  const RADIO_SELECTOR = "input[type='radio']";

  /*
   * Convert Dawn's visual .disabled state into a real
   * disabled radio button.
   */
  function updateDisabledStates(picker) {
    picker.querySelectorAll(RADIO_SELECTOR).forEach((radio) => {
      radio.disabled = radio.classList.contains('disabled');
    });
  }

  /*
   * Starting from Option 2, check whether each option group
   * still has a valid selected value.
   *
   * If not, click the first available value.
   *
   * Using click() is important because it lets Dawn perform
   * its normal variant-change processing.
   */
  function selectFirstAvailableIfNeeded(picker) {
    if (picker.dataset.autoVariantFallbackRunning === 'true') {
      return;
    }

    updateDisabledStates(picker);

    const groups = Array.from(
      picker.querySelectorAll(GROUP_SELECTOR)
    );

    /*
     * Start at index 1:
     *
     * 0 = Option 1, selected by the customer
     * 1 = Option 2, automatically corrected if necessary
     *
     * If you have Option 3, it will be handled too.
     */
    for (let i = 1; i < groups.length; i += 1) {
      const radios = Array.from(
        groups[i].querySelectorAll(RADIO_SELECTOR)
      );

      if (!radios.length) continue;

      const selected = radios.find((radio) => radio.checked);

      const selectedIsValid =
        selected &&
        !selected.disabled &&
        !selected.classList.contains('disabled');

      /*
       * Current selection is still valid.
       */
      if (selectedIsValid) {
        continue;
      }

      /*
       * Find first available value in this option group.
       */
      const firstAvailable = radios.find(
        (radio) =>
          !radio.disabled &&
          !radio.classList.contains('disabled')
      );

      if (!firstAvailable) {
        continue;
      }

      /*
       * Prevent our own click from creating an event loop.
       */
      picker.dataset.autoVariantFallbackRunning = 'true';

      firstAvailable.click();

      setTimeout(() => {
        delete picker.dataset.autoVariantFallbackRunning;

        /*
         * Dawn may have recalculated the next option group,
         * so check again.
         */
        scheduleUpdate(picker);
      }, 0);

      /*
       * Only change one group at a time.
       * Dawn must recalculate availability before we proceed.
       */
      return;
    }
  }

  function scheduleUpdate(picker) {
    clearTimeout(picker._autoVariantFallbackTimer);

    picker._autoVariantFallbackTimer = setTimeout(() => {
      selectFirstAvailableIfNeeded(picker);
    }, 50);
  }

  function initPicker(picker) {
    if (picker.dataset.autoVariantFallbackInitialized === 'true') {
      return;
    }

    picker.dataset.autoVariantFallbackInitialized = 'true';

    /*
     * When customer changes an option, wait for Dawn
     * to update availability and then validate the
     * following option groups.
     */
    picker.addEventListener('change', (event) => {
      if (!event.target.matches(RADIO_SELECTOR)) {
        return;
      }

      scheduleUpdate(picker);
    });

    /*
     * Dawn can replace/re-render the variant controls
     * after an option changes.
     *
     * Watching the picker makes the fallback happen
     * after that recalculation has actually occurred.
     */
    const observer = new MutationObserver(() => {
      scheduleUpdate(picker);
    });

    observer.observe(picker, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });

    /*
     * Apply initial disabled states.
     */
    scheduleUpdate(picker);
  }

  function initAllPickers(root = document) {
    root
      .querySelectorAll(PICKER_SELECTOR)
      .forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPickers();
    });
  } else {
    initAllPickers();
  }

  /*
   * Shopify Theme Editor support.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initAllPickers(event.target);
  });
})();